var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f03340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb212e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fc065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17a555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.047619h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 8.380952h16v3.047619h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.047619h16v5.333333h-16z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.35257031 7.12362014c.14717135-.14717136.14594159-.38701303-.00223724-.53519186l.15647671.1564767c-.14840695-.14840694-.43178885-.22794596-.63758632-.17649659l-.78606597.19651649c-.20372225.05093056-.22824678-.01325081-.06050618-.13905626l.90707834-.68030874c.17030561-.12772921.13973308-.2312742-.0785537-.2312742h-.36901856c-.21368963 0-.23523967-.07583981-.04873657-.16909136l.84744408-.42372205c.18677316-.09338657.16955021-.16909136-.04873657-.16909136h-.36901856c-.21368963 0-.2462943-.10546874-.0785537-.23127419l.90707837-.68030875c.1703056-.12772921.44899055-.12580544.61673112 0l.9070784.68030875c.1703056.12772921.13973303.23127419-.07855375.23127419h-.36901851c-.21368968 0-.2352397.07583982-.04873661.16909136l.84744411.42372205c.1867731.09338658.16955017.16909136-.04873661.16909136h-.36901851c-.21368968 0-.24629433.10546875-.07855376.2312742l.9070784.68030874c.17030558.12772922.14529128.19050563-.06050621.13905626l-.78606598-.19651649c-.20372228-.05093057-.48940746.02831777-.63758628.17649659l.15647665-.1564767c-.14840694.14840694-.1496669.38776216-.00223719.53519186l.2289501.22895013c.14717135.14717136.1020944.26647734-.11096191.26647734h-1.53083582c-.20845393 0-.2583916-.11904762-.11096191-.26647732z",
    fill: "url(#d)",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLb);
export default __webpack_public_path__ + "static/media/LB.1e57b3926b3a4cc6480ea56b9561f0c3.svg";
export { ForwardRef as ReactComponent };